module.exports = __webpack_public_path__ + "img/logo_text.4cd3e6b9.svg";